import * as React from 'react'
import { Divider } from '@mui/material'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

import { PW_OFFICES, PW_DETAILS, PW_WEBSITES, NZPM_DETAILS, PW_SOCIALS } from '../content'
import ContactUsForm from '../containers/ContactUsForm'
import ContactUsBreadcrumbs from '../containers/ContactUsBreadcrumbs'
import { RECAPTCHA_SITE_KEY } from '../../auth/content'

import '../styles/ContactUs.css'

export default class ContactUs extends React.PureComponent {

	render() {
		return (
			<React.Fragment>
				<ContactUsBreadcrumbs />

				<div className="contact-us">
					<h2 className="page-heading">CONTACT US</h2>

					<div className="contact-us__content">
						<div className="contact-us__contact">
							{/* Plumbing World Section Details */}
							<h4 className="contact-us__text--heading">Plumbing World Ltd</h4>

							<Divider className="contact-us__divider" />
							<br />

							<h5>Freephone | <a className="contact-us__text--phone" href={PW_DETAILS.url}>{PW_DETAILS.contact}</a></h5>
							<br />

							{PW_OFFICES.map(item => (
								<div key={item.name} className="contact-us__contact-item">
									<h5>{item.name} | <a className="contact-us__text--phone" href={item.url}>{item.contact}</a></h5>
									<h5 className="contact-us__text--light">{item.address}</h5>
								</div>
							))}
							<br />

							{PW_WEBSITES.map(item => (
								<h5 key={item.name} className="contact-us__contact-website">
									{item.name} | <a className="contact-us__text--light contact-us__url" href={item.url} target="_blank" rel="noopener noreferrer">{item.description}</a>
								</h5>
							))}
							<br />

							<h5>Follow us</h5>
							<div className="contact-us__social">
								{PW_SOCIALS.map(item => (
									<a key={item.icon} className="contact-us__url" href={item.url} target="_blank" rel="noopener noreferrer">
										<span className={`${item.icon} contact-us__icon contact-us__url`} />
									</a>
								))}
							</div>
							<br /><br />

							{/* NZPM Section Details */}
							<h4 className="contact-us__text--heading">NZPM Co-operative</h4>

							<Divider className="contact-us__divider" />
							<br />

							<div className="contact-us__contact-item">
								<h5>NZPM</h5>
								<h5 className="contact-us__text--light">{NZPM_DETAILS.address}</h5>
								<h5 className="contact-us__text--light">Postal Address: {NZPM_DETAILS.postalAddress}</h5>
								<h5 className="contact-us__text--light"><a target="_blank" rel="noopener noreferrer" className="contact-us__text--web" href={'https://' + NZPM_DETAILS.web}>{NZPM_DETAILS.web}</a></h5>
							</div>
						</div>

						<div className="contact-us__form">
							<h4 className="contact-us__text--heading">General Inquiries Form</h4>

							<Divider className="contact-us__divider" />
							<br />

							<GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_SITE_KEY}>
								<ContactUsForm />
							</GoogleReCaptchaProvider>
						</div>
					</div>
				</div>
			</React.Fragment>
		)
	}
}